import type {ChildrenProps} from './sidebar-context'
import styles from './Main.module.css'

export interface MainProps extends ChildrenProps {
  'aria-label': string
}

export function Main({children, 'aria-label': label}: MainProps) {
  return (
    <nav aria-label={label} className={styles.Main} data-component="Sidebar.Main">
      {children}
    </nav>
  )
}
